import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './App';
import logger from '@kemtai/logger'
import config from './config';

logger.init({
    app:    config.app, 
    url:    config.logServerUrl, 
    version: config.version,
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <App />
);
